module.exports = __webpack_public_path__ + "static/media/Email04-Image.40a59343.jpg";